export const Type = {
  leave_type: {
    1: "事假",
    2: "调休假",
    3: "病假",
    4: "年假",
    5: "婚假",
    6: "丧假",
    7: "其他类型",
  },
  status_type: {
    0: "审批中",
    1: "已通过",
    2: "不通过",
  },
  current_step: {
    1: "部门领导",
    2: "公司高管",
    3: "总经理",
    4: "hr",
  },
  invoice_status: {
    1: "银行转账",
    2: '银行承兑',
    3: '平安金融链'
  },
  commodity_type_data: {
    1: '主材',
    2: '辅材'
  },
  company_type_data: {
    1: '个体户',
    2: '小规模纳税人',
    3: '一般纳税人'
  }
};
